// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc9bac09","453":"cb339384","455":"344c819f","977":"ab92277a"}[chunkId] + ".chunk.js";
};